
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[region]/[resort]/pistekort",
      function () {
        return require("private-next-pages/[region]/[resort]/pistekort.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[region]/[resort]/pistekort"])
      });
    }
  